<template>
  <div class="ful-page">
    <div class="ful-page-wrapper">
      <PageHeader title="配送信息" @back="goBack" />
      <div class="ful-card">
        <div class="ful-body">
          <div class="space-y-7">
            <!-- 收件人信息 -->
            <section class="ful-section">
              <div class="ful-section-heading">
                <span class="ful-section-number">01</span>
                <svg class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <h2 class="ful-section-title">收件人信息</h2>
                <a style="color: #d35342; font-size: 14px; margin-left: auto; cursor: pointer;" @click="toAddressList">使用地址簿 (请先添加收件人信息)</a>
              </div>
              <el-form
                label-width="200px"
                label-position="right"
                class="ful-form-row"
                v-model="deliveryFormData"
                v-show="addressInfoVisible"
              >
                <el-form-item label="*姓名：" class="form-item">
                  <el-input v-model="deliveryFormData.receiverName" ref="nameId" type="text" placeholder="请输入收件人姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="*联系电话：" class="form-item">
                  <el-input @wheel.native.prevent v-model="deliveryFormData.phoneNo" ref="phoneId" type="number" placeholder="请输入联系人手机号码" clearable></el-input>
                </el-form-item>
                <el-form-item label="*省市区：" class="form-item">
                  <el-cascader class="address-picker" ref="adressCas" placeholder="请选择省市区" @change="addressChange" :value="addressInfo" :props="props"></el-cascader>
                  <span v-show="addressTemp && addressTemp.length > 0" style="position: absolute; color: #606266; background-color: white; left: 10px; line-height: 20px; width: 300px; text-align: start; font-size: 18px; z-index: 1;">{{ addressTemp }}</span>
                </el-form-item>
                <el-form-item label="*详细地址：" class="form-item">
                  <el-input v-model="deliveryFormData.street" ref="customAddressId" type="text" placeholder="请输入详细地址(街道门牌信息)" clearable></el-input>
                </el-form-item>
                <el-form-item label="邮政编码：" class="form-item">
                  <el-input @wheel.native.prevent v-model="deliveryFormData.zipCode" type="number" placeholder="请输入邮政编码" clearable></el-input>
                </el-form-item>
              </el-form>
            </section>

            <!-- 配送信息（定制茶独有，动态表单已简化） -->
            <section class="ful-section">
              <div class="ful-section-heading">
                <span class="ful-section-number">02</span>
                <svg class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>
                <h2 class="ful-section-title">配送服务</h2>
              </div>
              <el-form label-width="200px" label-position="right" class="ful-form-row" :model="drugFormData" @submit.native.prevent>
                <!-- 形态：普通用户固定，非普通用户可选 -->
                <el-form-item class="radio-container" label="*形态：" v-if="!isNormalUser">
                  <div class="ful-radio-group">
                    <el-radio-group v-model="drugFormData.currentFormName" v-for="value in forms" :key="value.formCode" @change="radioChange">
                      <el-radio-button class="radio-button" :label="value.formName" :disabled="value.isUser == 1" border>{{ value.formName }}</el-radio-button>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <el-form-item class="form-item" label="*形态：" v-else>
                  <span style="font-size: 18px; color: #333;">私人定制养生茶</span>
                </el-form-item>
                <div class="ful-hint">请先选择中草药形态</div>
                <!-- 配送中心：普通用户固定，非普通用户可选 -->
                <el-form-item class="form-item" label="*请选择配送中心：" v-if="!isNormalUser">
                  <div class="ful-form-control">
                    <el-select v-model="deliveryFormData.deliveryId" clearable placeholder="请选择" @change="getConfigAndDeliveryId" style="flex: 1; min-width: 200px;">
                      <el-option v-for="item in options" :key="item.deliveryId" :label="item.deliveryName" :value="item.deliveryId"></el-option>
                    </el-select>
                    <button class="ful-btn-ghost" @click.prevent="switchList(isswitchList)">{{ isswitchList }}</button>
                  </div>
                </el-form-item>
                <el-form-item class="form-item" label="*配送中心：" v-else>
                  <span style="font-size: 18px; color: #333;">百草元和配送中心（固定）</span>
                </el-form-item>
                <!-- 几盒 -->
                <el-form-item label="*几盒：" class="form-item">
                  <el-input @wheel.native.prevent v-model="drugFormData.drugCount" ref="drugCountId" type="number" @input="handleInput" autocomplete="off" placeholder="请输入几盒，只能是大于0 的数字。" @keyup.native.enter></el-input>
                </el-form-item>
                <div class="ful-hint">私人定制养生茶：一盒内含48袋，每袋5克，一天一袋，可反复冲泡服用</div>
                <!-- 备注 -->
                <el-form-item label="备注：" class="form-item" style="margin-top: 20px">
                  <el-input v-model="drugFormData.remark" type="textarea" placeholder="如有特殊需求请注明" autosize maxlength="100" show-word-limit></el-input>
                </el-form-item>
              </el-form>
            </section>
          </div>
          
          <!-- 配送摘要 -->
          <aside class="ful-sidebar">
            <div class="ful-sidebar-title">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
              配送摘要
            </div>
            <dl v-if="consultInfo">
              <div style="display: flex; justify-content: space-between; gap: 16px;"><dt>病人姓名</dt><dd>{{ consultInfo.name }}</dd></div>
              <div style="display: flex; justify-content: space-between; gap: 16px;"><dt>定制类型</dt><dd>{{ isNormalUser ? '私人定制养生茶' : (currentForm.formName || '-') }}</dd></div>
              <div style="display: flex; justify-content: space-between; gap: 16px;"><dt>数量</dt><dd>{{ drugFormData.drugCount || '0' }} 盒</dd></div>
              <div class="divider"><dt>配送中心</dt><dd>{{ isNormalUser ? '百草元和配送中心（固定）' : (deliveryFormData.deliveryId || '-') }}</dd></div>
            </dl>
            <dl v-else><div style="color: #94a3b8; font-size: 14px;">加载中...</div></dl>
          </aside>
        </div>
        
        <!-- 底部查询信息 -->
        <div class="ful-bottom">
          <section style="max-width: 1050px; margin: 0 auto;">
            <div class="ful-collapse-header" @click="activeNames = activeNames == '1' ? '' : '1'">
              <span>基本信息</span>
              <svg class="ful-collapse-icon" :class="{ 'is-open': activeNames == '1' }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </div>
            <div v-show="activeNames == '1'" class="ful-collapse-content">
              <span v-if="consultInfo">姓名：{{ consultInfo.name }}</span>
              <span v-if="consultInfo">性别：{{ consultInfo.sex == '1' ? '男' : '女' }}</span>
              <span v-if="consultInfo">电话：{{ consultInfo.phoneNo }}</span>
              <span v-if="consultInfo">出生日期：{{ consultInfo.birthday }}<!-- 出生时分 暂时隐藏（保留代码，恢复时去掉注释即可）<span v-if="shouldShowTime(consultInfo.birthHour, consultInfo.birthMinute)"> {{ formatTimeValue(consultInfo.birthHour) }}:{{ formatTimeValue(consultInfo.birthMinute) }}</span> --></span>
              <span v-if="consultInfo">常住地址：{{ consultInfo.liveArea }}</span>
              <span v-if="consultInfo">出生地址：{{ consultInfo.birthArea }}</span>
              <span v-if="consultInfo && consultInfo.useDate">开始服药时间：{{ consultInfo.useDate }}</span>
              <span v-if="consultInfo && consultInfo.useDays">服药天数：{{ consultInfo.useDays }}</span>
            </div>
            
            <div class="ful-collapse-header" @click="activeNames = activeNames == '3' ? '' : '3'">
              <span> {{ pane.title || '处方' }}</span>
              <svg class="ful-collapse-icon" :class="{ 'is-open': activeNames == '3' }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </div>
            <div v-show="activeNames == '3'" class="ful-collapse-content">
              <span v-if="consultInfo">姓名：{{ consultInfo.name }}</span>
              <span v-if="consultInfo">性别：{{ consultInfo.sex == '1' ? '男' : '女' }}</span>
              <span v-if="consultInfo">电话：{{ consultInfo.phoneNo }}</span>
              <span v-if="consultInfo">出生日期：{{ consultInfo.birthday }}<!-- 出生时分 暂时隐藏（保留代码，恢复时去掉注释即可）<span v-if="shouldShowTime(consultInfo.birthHour, consultInfo.birthMinute)"> {{ formatTimeValue(consultInfo.birthHour) }}:{{ formatTimeValue(consultInfo.birthMinute) }}</span> --></span>
              <span v-if="consultInfo">常住地址：{{ consultInfo.liveArea }}</span>
              <span v-if="consultInfo">出生地址：{{ consultInfo.birthArea }}</span>
              <span v-if="consultInfo && consultInfo.useDate">开始服药时间：{{ consultInfo.useDate }}</span>
              <span v-if="consultInfo && (consultInfo.useDays || consultInfo.ganZhiPrescriptionHourRange)">
                {{ consultInfo.ganZhiPrescriptionHourRange ? '服药时间段' : '服药天数' }}：{{ consultInfo.ganZhiPrescriptionHourRange || consultInfo.useDays }}
              </span>
            </div>
          </section>
          
          <div class="ful-actions">
            <button class="ful-btn-submit" @click="submit">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>
              统一配送
            </button>
            <!-- <button class="ful-btn-draft" @click="saveDraft">保存草稿</button> -->
          </div>
        </div>
      </div>
    </div>
    
    <ConfirmDialog :visible.sync="dialogVisible" @confirm="confirmOrder">
      <li><b>病人姓名：</b>{{ consultInfo.name }}</li>
      <li><b>中草药形态：</b>{{ currentForm.formName }}</li>
      <li><b>几盒：</b>{{ drugFormData.drugCount }}</li>
      <li v-if="drugFormData.quantityDispensed"><b>{{ adjustmentQuantityType }}：</b>{{ drugFormData.quantityDispensed }}</li>
      <li v-if="drugFormData.specifications"><b>{{ specificationType }}：</b>{{ drugFormData.specifications }}</li>
      <li v-if="drugFormData.frequency"><b>{{ frequencyString }}：</b>{{ drugFormData.frequency }}</li>
      <li v-if="drugFormData.dosage"><b>{{ dosageString }}：</b>{{ drugFormData.dosage }}</li>
      <li v-if="drugFormData.prescriptionWithShipment"><b>处方笺寄送：</b>{{ drugFormData.prescriptionWithShipment }}</li>
      <li><b>收件人姓名：</b>{{ deliveryFormData.receiverName }}</li>
      <li><b>收件人联系方式：</b>{{ deliveryFormData.phoneNo }}</li>
      <div class="dialog-address"><b>收件地址：</b>{{ deliveryFormData.province + deliveryFormData.city + deliveryFormData.county + deliveryFormData.street }}</div>
      <li><b>备注：</b>{{ drugFormData.remark != null && drugFormData.remark.length == 0 ? '无' : drugFormData.remark }}</li>
    </ConfirmDialog>
  </div>
</template>

<script>
import PageHeader from "@/components/widgets/PageHeader.vue";
import ConfirmDialog from "@/components/widgets/ConfirmDialog.vue";
import fulfillmentMixin from "../../js/fulfillmentMixin";

export default {
  name: "fulConfirm",
  components: { PageHeader, ConfirmDialog },
  mixins: [fulfillmentMixin],
  data() {
    return {
      isNormalUser: false,
      visitRecordId: "",
    };
  },
  created() {
    console.log("created");
    this.isNormalUser = this.checkNormalUser();
    var cacheData = sessionStorage.getItem('fulfillmentConfirmCache');
    if (!cacheData) { this.getMedicineform(); }
  },
  mounted() {
    var mode = this.$route.query.mode;
    console.log(mode, "xxxxxxxxxx");
    var cacheData = sessionStorage.getItem('fulfillmentConfirmCache');
    if (cacheData) {
      var cache = JSON.parse(cacheData);
      this.drugFormData = cache.drugFormData;
      this.deliveryFormData = cache.deliveryFormData;
      this.addressInfo = cache.addressInfo;
      this.addressTemp = cache.addressTemp;
      this.currentForm = cache.currentForm;
      this.addressInfoVisible = cache.addressInfoVisible;
      this.options = cache.options || [];
      this.forms = cache.forms || [];
      this.isswitchList = cache.isswitchList || "其他";
      sessionStorage.removeItem('fulfillmentConfirmCache');
    }
    this.prescription = JSON.parse(sessionStorage.getItem("serviceInfo"));
    this.consultInfo = JSON.parse(sessionStorage.getItem("consultInfo"));
    // visitRecordId 优先取路由 query（由 Prescription.vue 跳转时传入），否则回退到 serviceInfo 中的 prescription
    this.visitRecordId = this.$route.query.visitRecordId || (this.prescription && this.prescription.visitRecordId) || "";
    var index = this.$route.query.index;
    this.prescriptionNo = index;
    this.tablePrescription = JSON.parse(sessionStorage.getItem("tablePrescription"));
    this.pane = this.tablePrescription ? this.tablePrescription[index] : {};
    if (!cacheData) {
      this.wjtHttp.get(
        this, "/api/medicine/v2/forms/customTea", {}, false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.forms = data.data;
            console.log(this.forms, "获取中草药形态异常");
            if (this.isNormalUser) { this.applyNormalUserFixedSelection(); }
            else if (mode == 1) { this.getDraft(); }
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "获取中草药形态异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    }
    var address = sessionStorage.getItem("selectAddress");
    console.log("我的地址：", address);
    if (address != null && address.length > 0) {
      var addressObj = JSON.parse(address);
      this.deliveryFormData.receiverName = addressObj.receiverName;
      this.deliveryFormData.phoneNo = addressObj.phoneNo;
      this.deliveryFormData.province = addressObj.province;
      this.deliveryFormData.city = addressObj.city;
      this.deliveryFormData.county = addressObj.county;
      this.addressInfo = addressObj.addressInfo;
      this.deliveryFormData.street = addressObj.street;
      this.deliveryFormData.zipCode = addressObj.zipCode;
      this.addressTemp = addressObj.addressInfo[0] + "/" + addressObj.addressInfo[1] + "/" + addressObj.addressInfo[2];
      console.log("updateAddress:");
      console.log(this.deliveryFormData);
      this.addressInfoVisible = true;
    }
    sessionStorage.removeItem("selectAddress");
  },
  methods: {
    checkNormalUser() {
      var userInfo = this.$store.getters.getUserInfo;
      if (!userInfo) return false;
      var roles = userInfo.roles;
      if (!roles || roles.length == 0) return false;
      var specialKeys = ["superadmin", "admin", "level1", "level2", "doctor", "common_doctor", "common_hospital_admin", "hospital_admin"];
      for (var i = 0; i < roles.length; i++) {
        if (specialKeys.indexOf(roles[i]) >= 0) { return false; }
      }
      return true;
    },
    applyNormalUserFixedSelection() {
      var targetForm = this.forms.find((item) => item.formCode == "R");
      if (targetForm) {
        this.currentForm = targetForm;
        this.drugFormData.currentFormName = targetForm.formName;
        this.drugFormData.formCode = targetForm.formCode;
      } else {
        this.currentForm = { formCode: "R", formName: "私人定制养生茶" };
        this.drugFormData.currentFormName = "私人定制养生茶";
        this.drugFormData.formCode = "R";
      }
      this.deliveryFormData.deliveryId = 447;
    },
    radioChange() {
      this.currentForm = this.forms.find((item) => item.formName == this.drugFormData.currentFormName);
      this.isswitchList = "其他";
      this.addSelect();
      console.log(this.drugFormData.currentFormName, "1111111111111111111");
    },
    submit() {
      if (!this.isNormalUser) {
        if (this.drugFormData.currentFormName.length == 0) {
          this.$message("请选择一个中草药形态");
          return;
        }
        if (!this.deliveryFormData.deliveryId) {
          this.$message("请选择配送中心");
          return;
        }
      }
      if (this.drugFormData.drugCount <= 0) {
        this.$nextTick(() => { this.$refs.drugCountId.focus(); });
        this.$message("请输入几副药，只能是大于0的数字");
        return;
      }
      if (this.deliveryFormData.receiverName.length == 0) {
        this.$nextTick(() => { this.$refs.nameId.focus(); });
        this.$message("请输入收件人姓名");
        return;
      }
      if (this.deliveryFormData.phoneNo.length != 11) {
        this.$nextTick(() => { this.$refs.phoneId.focus(); });
        this.$message("请输入正确的11位手机号");
        return;
      }
      if (this.addressInfo.length == 0) {
        this.$message("请选择省市区");
        return;
      }
      if (this.deliveryFormData.street.length == 0) {
        this.$nextTick(() => { this.$refs.customAddressId.focus(); });
        this.$message("请输入详细地址");
        return;
      }
      this.dialogVisible = true;
    },
    getMedicineform() {
      var test = JSON.parse(sessionStorage.getItem("prescription"));
      console.log(test, 77777888888888);
      console.log(test.type, 66666888888888);
      var mode = this.$route.query.mode;
      this.wjtHttp.get(
        this, "/api/medicine/v2/forms/" + test.type, {}, false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.forms = data.data;
            if (this.isNormalUser) { this.applyNormalUserFixedSelection(); }
            else if (mode == 1) { this.getDraft(); }
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "获取中草药形态异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    },
    confirmOrder() {
      this.dialogVisible = false;
      this.wjtHttp.post(
        this, "/api/delivery/orderCustomTea/place",
        {
          deliveryType: "E",
          startDate: this.consultInfo.useDate,
          endDate: "47121231",
          type: "customTea",
          form: this.currentForm.formCode,
          remark: this.drugFormData.remark,
          formCount: this.drugFormData.drugCount,
          zipCode: this.deliveryFormData.zipCode,
          recipientAddress: this.deliveryFormData.province + this.deliveryFormData.city + this.deliveryFormData.county + this.deliveryFormData.street,
          recipientName: this.deliveryFormData.receiverName,
          recipientPhone: this.deliveryFormData.phoneNo,
          visitRecordId: this.visitRecordId || (this.prescription && this.prescription.visitRecordId) || "",
          deliveryId: this.deliveryFormData.deliveryId,
          prescriptionNo: this.prescriptionNo,
        },
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.$router.replace({ path: "/CUSTOMIZEDfulfillmentOrder", query: { orderId: data.data.deliveryOrderId } });
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "生成统一配送订单异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    },
    getDraft() {
      this.wjtHttp.post(
        this, "/api/delivery/order/draft/info",
        { startDate: this.prescription.startDate, type: this.prescription.type, visitRecordId: this.prescription.visitRecordId },
        true,
        (res) => {
          if (res.data.data) {
            this.draftInfo = res.data.data;
            this.consultInfo = res.data.data.patient;
            this.setDraftInfo();
            this.generateTableData();
          }
        },
        (err) => {}
      );
    },
    saveDraft() {
      if (!this.isNormalUser) {
        if (this.drugFormData.currentFormName.length == 0) {
          this.$message("请选择一个中草药形态");
          return;
        }
      }
      if (this.drugFormData.drugCount.length == 0 || this.drugFormData.drugCount == 0) {
        this.$nextTick(() => { this.$refs.drugCountId.focus(); });
        this.$message("请输入几副药，只能是大于0的数字");
        return;
      }
      if (this.deliveryFormData.receiverName.length == 0) {
        this.$nextTick(() => { this.$refs.nameId.focus(); });
        this.$message("请输入收件人姓名");
        return;
      }
      if (this.deliveryFormData.phoneNo.length == 0) {
        this.$nextTick(() => { this.$refs.phoneId.focus(); });
        this.$message("请输入收件人联系方式");
        return;
      }
      if (this.addressInfo.length == 0) {
        this.$message("请选择省市区");
        return;
      }
      if (this.deliveryFormData.street.length == 0) {
        this.$nextTick(() => { this.$refs.customAddressId.focus(); });
        this.$message("请输入详细地址");
        return;
      }
      this.wjtHttp.post(
        this, "/api/delivery/order/draft/save",
        {
          deliveryType: "E",
          form: this.currentForm.formCode,
          formCount: this.drugFormData.drugCount,
          recipientName: this.deliveryFormData.receiverName,
          recipientPhone: this.deliveryFormData.phoneNo,
          recipientAddress: this.deliveryFormData.province + this.deliveryFormData.city + this.deliveryFormData.county + this.deliveryFormData.street,
          province: this.deliveryFormData.province,
          city: this.deliveryFormData.city,
          county: this.deliveryFormData.county,
          street: this.deliveryFormData.street,
          zipCode: this.deliveryFormData.zipCode,
          remark: this.drugFormData.remark,
          startDate: this.prescription.startDate,
          type: this.prescription.type,
          visitRecordId: this.prescription.visitRecordId,
        },
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "保存草稿成功" });
          } else {
            this.$message({ message: data.msg && data.msg.length > 0 ? data.msg : "保存草稿异常", type: "error" });
          }
        },
        (err) => { console.log(err); }
      );
    },
    addSelect() {
      this.wjtHttp.get(
        this, "api/delivery/getCurrentDeliveryDept",
        { formCode: this.drugFormData.currentFormName },
        null,
        (res) => {
          var data = res.data;
          this.options = data.data;
          console.log(this.options, "99999999999");
        }
      );
    },
  },
};
</script>

<style scoped>
.hidden-sm { display: none; }
@media (min-width: 640px) {
  .hidden-sm { display: block; }
}
.ful-sidebar dt {
  color: #000;
}
.ful-sidebar dd {
  color: #000;
  font-weight: 400;
}
</style>
